/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free g-force calculator. Convert between centrifuge speed (RPM) and relative centrifugal force (RCF, ×g) from the rotor radius, in both directions.`)
};

const es_gf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de fuerza g gratuita. Convierte entre velocidad de centrífuga (RPM) y fuerza centrífuga relativa (RCF, ×g) a partir del radio del rotor, en ambas direcciones.`)
};

const de_gf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser G-Kraft-Rechner. Rechnen Sie anhand des Rotorradius in beide Richtungen zwischen Zentrifugendrehzahl (RPM) und relativer Zentrifugalkraft (RCF, ×g) um.`)
};

const nl_gf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis g-krachtcalculator. Reken om tussen centrifugesnelheid (RPM) en relatieve centrifugale kracht (RCF, ×g) op basis van de rotorstraal, in beide richtingen.`)
};

const fr_gf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de force g gratuit. Convertissez entre la vitesse de la centrifugeuse (RPM) et la force centrifuge relative (RCF, ×g) à partir du rayon du rotor, dans les deux sens.`)
};

const it_gf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito della forza G. Converti tra velocità della centrifuga (RPM) e forza centrifuga relativa (RCF, ×g) a partire dal raggio del rotore, in entrambe le direzioni.`)
};

const pt_br2_gf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de força g gratuita. Converta entre velocidade da centrífuga (RPM) e força centrífuga relativa (RCF, ×g) a partir do raio do rotor, nos dois sentidos.`)
};

const pt_gf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de força g gratuita. Converta entre a velocidade da centrífuga (RPM) e a força centrífuga relativa (RCF, ×g) a partir do raio do rotor, em ambas as direções.`)
};

const ja_gf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の遠心力計算機です。ローター半径から、遠心分離機の回転速度(RPM)と相対遠心力(RCF、×g)を双方向に変換できます。`)
};

const zh_gf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费离心力计算器。根据转子半径，在离心机转速（RPM）与相对离心力（RCF，×g）之间双向换算。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_meta_description", locale)
	if (locale === "en") return en_gf_meta_description(inputs)
	if (locale === "es") return es_gf_meta_description(inputs)
	if (locale === "de") return de_gf_meta_description(inputs)
	if (locale === "nl") return nl_gf_meta_description(inputs)
	if (locale === "fr") return fr_gf_meta_description(inputs)
	if (locale === "it") return it_gf_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_gf_meta_description(inputs)
	if (locale === "pt") return pt_gf_meta_description(inputs)
	if (locale === "ja") return ja_gf_meta_description(inputs)
	return zh_gf_meta_description(inputs)
};